import { render, staticRenderFns } from "./NumbersList.vue?vue&type=template&id=54fcf595&scoped=true&"
import script from "./NumbersList.vue?vue&type=script&lang=js&"
export * from "./NumbersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fcf595",
  null
  
)

export default component.exports